module.exports = __webpack_public_path__ + "static/media/menu.a3685fcb.svg";